import { render, staticRenderFns } from "./AreaTotal.vue?vue&type=template&id=0403e8f6&scoped=true"
import script from "./AreaTotal.vue?vue&type=script&lang=js"
export * from "./AreaTotal.vue?vue&type=script&lang=js"
import style0 from "./AreaTotal.vue?vue&type=style&index=0&id=0403e8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0403e8f6",
  null
  
)

export default component.exports